import React from 'react'
import { t } from 'ttag'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Icon, LogOutIcon } from 'components/shared/Icon/Icon'

import styles from './Logout.module.scss'

export const Logout = ({ onLogOut }) => (
  <Dropdown.MenuItem className={styles.logout}>
    <Dropdown.Action onClick={onLogOut}>
      <Icon className={styles.icon} icon={LogOutIcon} size={20} />
      <span>{t`Log out`}</span>
    </Dropdown.Action>
  </Dropdown.MenuItem>
)
